import { render } from "./AddDistributorModal.vue?vue&type=template&id=78cd92e7&ts=true"
import script from "./AddDistributorModal.vue?vue&type=script&lang=ts"
export * from "./AddDistributorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__